import {RangeIndicator} from "./RangeIndicator.js";
import {onVisible} from '@megaphonenpm/mputils/src/DOM.js';

export class DialIndicatorComponent extends RangeIndicator {
  constructor (themeID) {
    super(themeID, 'moodmeterDial');
  }

  build () {
    super.build();

    // Pre-flight check
    if (!this.valid) {
      return;
    }

    this.needle = this.view.querySelector('.moodmeterNeedle');
    this.dial = this.view.querySelector('.moodmeterDialBG');

    onVisible(this.view, () => {
      let needleWidth = this.needle.offsetWidth;
      let needleHeight = this.needle.offsetHeight;
      let dialWidth = this.dial.offsetWidth;
      let dialHeight = this.dial.offsetHeight;
      this.needle.style.transformOrigin = '100% 50%';
      this.needle.style.marginTop = `${dialHeight-needleHeight/2}px`;
      this.needle.style.marginLeft = `${dialWidth/2 - needleWidth}px`;
    });

  }

  disableAnimation () {
    this.needle.classList.remove('transitionTransform');
  }

  enableAnimation () {
    this.needle.classList.add('transitionTransform');
  }

  setValue (percent) {
    super.setValue(percent);
    let rotation =  0;
    if (percent > 0) {
      // Needle configuration:
      // 1) Limit the rotational range of the dial's needle to between 10 and 170 degrees.
      //    For "0%", position the needle at 10 degrees.
      //    For "100%", position the needle at 170 degrees.
      // 2) In Megaphone polls, the minimum possible vote is 1, so when the percentage is greater
      //    than zero, position the needle using the range "1 to numAnwers" rather "0 to numAnswers".
      let rotationRange = 160;
      percent = percent/100;  // Convert percent to decimal (e.g., .3)
      let minimumVotePercent = 1/this.numSegments;  // For a Mood Meter with 10 answers, this is .1
      let percentOfRange = (percent-minimumVotePercent) / (1-minimumVotePercent);  // For a Mood Meter with 10 answers, this maps 0-10 to 1-10
      let minimumRotation = (180-rotationRange)/2;  // E.g., If rotationRange is 160 degrees, minimumRotation will be 10 degrees
      rotation = minimumRotation + (percentOfRange*rotationRange);
    }
    // Rotate the needle
    // The "perspective(0)" is a magic trick required to fix a bug in Chrome and Safari on macOS, where the
    // image disappears when rotated if the rotation is 10 or 170 and the root scale is 1.38 or greater. See:
    // https://stackoverflow.com/questions/39749540/why-wont-emojis-render-when-rotated-to-45-or-315-degrees
    this.needle.style.transform = `rotate(${rotation}deg)  perspective(0)`;
  }

  setSize (width, height) {
    super.setSize(width, height);
    this.dial.style.height = `${height}px`;
    this.dial.style.height = `${height}px`;
  }
}